import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import './modal.scss';

const defaultLayerStyles = {
    position: 'fixed',
    overflow: 'auto',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: '1000',
    overflowScrolling: 'touch',
    outline: '0',
    textAlign: 'center',
    fontSize: '0',
    whiteSpace: 'nowrap',
    background: 'rgba(0,0,0,.57)'
};

const defaultContentStyles = {
    zIndex: '999'
    // minWidth: '400px',
    // minHeight: '200px'
};

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.removeModal = this.removeModal.bind(this);
        this.handleCloseOnEsc = this.handleCloseOnEsc.bind(this);
    }

    componentDidMount() {
        if (this.props.closeAfterTimeMS) {
            this.timeID = setTimeout(() => {
                this.removeModal();
            }, this.props.closeAfterTimeMS);
        }
        if (this.node) {
            document.body.appendChild(this.node);
        }
        if (this.props.closeOnEsc) { // handle esc event
            window.addEventListener('keyup', this.handleCloseOnEsc);
        }
        this.preOverflow = document.body.style.overflow;
        // document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        if (this.props.closeOnEsc) {
            window.removeEventListener('keyup', this.handleCloseOnEsc);
        }
        document.body.removeChild(this.node);
        document.body.style.overflow = this.preOverflow;
    }

    handleCloseOnEsc(evt) {
        if (evt.keyCode === 27) {
            this.removeModal();
        }
    }

    removeModal() {
        if (this.timeID) {
            this.timeID = null;
        }
        if (typeof this.props.onClose === 'function') {
            this.props.onClose(this.props.id);
        } else {
            document.body.removeChild(this.node);
        }
    }

    render() {
        const modalLayerProps = {
            style: defaultLayerStyles,
            className: ''
        };
        const modalContentProps = {
            style: defaultContentStyles
        };
        const {
            contentStyle,
            layerStyle,
            contentClass,
            layerClass,
            children,
            isClose,
            onClose,
            visible
        } = this.props;

        if (contentStyle) {
            modalContentProps.style = Object.assign(modalContentProps.style, contentStyle);
        }

        if (layerStyle) {
            modalLayerProps.style = Object.assign(modalLayerProps.style, layerStyle);
        }

        if (contentClass) {
            modalContentProps.className = contentClass;
        }

        if (layerClass) {
            modalLayerProps.className = layerClass;
        }

        modalLayerProps.className += ' modal-layer';

        if (!this.node) {
            this.node = document.createElement('div');
        }

        const modalLayer = (
            <React.Fragment>
                <div className="modal-backdrop"></div>
                <div className={modalLayerProps.className} style={modalLayerProps.style}>
                    {isClose && (
                        <div className="modal-close" onClick={onClose}>
                           <img className="modal-close-icon" src='static/img/popup_close.png' />
                        </div>
                    )}
                    <div className={modalContentProps.className} style={modalContentProps.style}>
                        {children}
                    </div>
                </div>
            </React.Fragment >
        );
        return visible ? ReactDOM.createPortal(modalLayer, this.node) : null;
    }
}

Modal.propTypes = {
    visible: PropTypes.bool,
    isClose: PropTypes.bool,
    closeAfterTimeMS: PropTypes.bool,
    closeOnEsc: PropTypes.bool,
    onClose: PropTypes.func,
    contentStyle: PropTypes.string,
    layerStyle: PropTypes.string,
    contentClass: PropTypes.string,
    layerClass: PropTypes.string,
    children: PropTypes.node.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Modal.defaultProps = {
    visible: false,
    isClose: true,
    closeAfterTimeMS: false,
    closeOnEsc: true
};

export default Modal;
